module.exports = __webpack_public_path__ + "img/header_bg.5cbe399e.png";